import { Layout } from "../types/Layout";

export const LAYOUT_DEFAULT_STATE: Layout = {
  isSidebarCollapsed: false,
};

export enum PORTALS {
  EMAILER = "sider-bottom-widget",
}
